(() => {
  let dialogTrigger;
  const desktop = window.matchMedia('(min-width: 781px)');
  const applyArchiveFilter = () => {
    const value = ['lookbook', 'editorial'].includes(location.hash.slice(1)) ? location.hash.slice(1) : 'all';
    document.querySelectorAll('.archives-page').forEach(section => {
      section.querySelectorAll('[data-archive-filter]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.archiveFilter === value)));
      section.querySelectorAll('[data-archive-type]').forEach(card => { card.hidden = value !== 'all' && card.dataset.archiveType !== value; });
    });
  };
  const toggleCategory = button => {
    const item = button.closest('li');
    const active = !item.classList.contains('is-open');
    Array.from(item.parentElement.children).forEach(sibling => {
      sibling.classList.remove('is-open');
      sibling.querySelector(':scope > button')?.setAttribute('aria-expanded', 'false');
    });
    item.classList.toggle('is-open', active);
    button.setAttribute('aria-expanded', String(active));
  };
  desktop.addEventListener('change', () => {
    const menu = document.getElementById('MobileMenu');
    if (desktop.matches && menu?.open) menu.close();
  });
  window.addEventListener('hashchange', applyArchiveFilter);
  window.addEventListener('popstate', applyArchiveFilter);
  const openDialog = (id, trigger) => {
    const dialog = document.getElementById(id);
    if (!dialog || dialog.open) return;
    dialogTrigger = trigger;
    dialog.showModal();
    if (id === 'SearchDialog') dialog.querySelector('input[type="search"]')?.focus();
    if (id === 'MobileMenu') document.body.classList.add('mobile-menu-open');
    document.documentElement.style.overflow = 'hidden';
    trigger?.setAttribute('aria-expanded', 'true');
  };
  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-variant-picker][open]').forEach(picker => {
      if (!picker.contains(event.target)) picker.open = false;
    });
    if (!event.target.closest('.desktop-nav')) document.querySelectorAll('.desktop-nav .nav-group').forEach(item => {
      item.classList.remove('is-open');
      item.querySelector(':scope > a')?.setAttribute('aria-expanded', 'false');
      if (item.contains(document.activeElement)) { item.classList.add('nav-dismissed'); document.activeElement.blur(); }
    });
    const search = event.target.closest('[data-search-open]');
    const menu = event.target.closest('.menu-toggle');
    const close = event.target.closest('[data-close-dialog]');
    const expand = event.target.closest('.nav-expand,.sub-expand');
    const groupLink = event.target.closest('.nav-group > a');
    if (groupLink && groupLink.textContent.trim().toUpperCase() === 'ARCHIVES' && groupLink.parentElement.querySelector('.nav-children')) {
      event.preventDefault();
      if (groupLink.closest('.mobile-menu')) toggleCategory(groupLink.parentElement.querySelector('.nav-expand'));
      else {
        groupLink.parentElement.classList.remove('nav-dismissed');
        const open = groupLink.parentElement.classList.toggle('is-open');
        groupLink.setAttribute('aria-expanded', String(open));
      }
    } else if (event.target.closest('#MobileMenu a')) document.getElementById('MobileMenu').close();
    if (search) openDialog('SearchDialog', search);
    if (menu) openDialog('MobileMenu', menu);
    if (close) close.closest('dialog').close();
    if (expand) {
      toggleCategory(expand);
    }
    const filter = event.target.closest('[data-archive-filter]');
    if (filter) {
      const url = new URL(location.href);
      url.hash = filter.dataset.archiveFilter === 'all' ? '' : filter.dataset.archiveFilter;
      if (url.hash !== location.hash) history.pushState({}, '', url);
      applyArchiveFilter();
    }
    const arrow = event.target.closest('[data-gallery-prev],[data-gallery-next]');
    if (arrow) {
      const gallery = arrow.closest('.pdp').querySelector('.pdp-gallery');
      gallery.scrollBy({ left: gallery.clientWidth * (arrow.hasAttribute('data-gallery-next') ? 1 : -1), behavior: 'smooth' });
    }
  });
  const init = (root = document) => {
    root.querySelectorAll('.desktop-nav .nav-group').forEach(item => {
      const link = item.querySelector(':scope > a');
      const title = link.textContent.trim().toUpperCase();
      item.classList.toggle('nav-direct', title === 'WOMEN' || title === 'MEN');
      if (title === 'ARCHIVES') { link.setAttribute('aria-expanded', 'false'); link.setAttribute('aria-haspopup', 'true'); }
      if (!item.dataset.initialized) {
        item.dataset.initialized = 'true';
        item.addEventListener('keydown', event => {
          if (event.key === 'Escape') {
            item.classList.remove('is-open');
            item.classList.add('nav-dismissed');
            link.setAttribute('aria-expanded', 'false');
            link.focus();
          }
        });
        item.addEventListener('pointerenter', () => item.classList.remove('nav-dismissed'));
        item.addEventListener('focusout', event => {
          if (!item.contains(event.relatedTarget)) { item.classList.remove('nav-dismissed', 'is-open'); link.setAttribute('aria-expanded', 'false'); }
        });
      }
    });
    root.querySelectorAll('.mobile-menu .nav-children li').forEach(item => {
      if (!item.querySelector(':scope > ul') || item.querySelector(':scope > button')) return;
      item.classList.add('nav-subgroup');
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'sub-expand';
      button.setAttribute('aria-label', `Expand ${item.querySelector(':scope > a')?.textContent || 'category'}`);
      button.setAttribute('aria-expanded', 'false');
      button.textContent = '⌄';
      item.insertBefore(button, item.querySelector(':scope > ul'));
    });
    root.querySelectorAll('dialog').forEach(dialog => {
      if (dialog.dataset.initialized) return;
      dialog.dataset.initialized = 'true';
      dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = '';
        document.body.classList.remove('mobile-menu-open');
        dialogTrigger?.setAttribute('aria-expanded', 'false');
        if (dialogTrigger?.isConnected && dialogTrigger.getClientRects().length) dialogTrigger.focus();
      });
      dialog.addEventListener('click', event => {
        const r = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom)) dialog.close();
      });
    });
    root.querySelectorAll('.pdp-gallery').forEach(gallery => {
      if (gallery.dataset.initialized) return;
      gallery.dataset.initialized = 'true';
      const update = () => {
        const counter = gallery.closest('.pdp').querySelector('[data-gallery-counter]');
        const index = Math.max(0, Math.min(gallery.children.length - 1, Math.round(gallery.scrollLeft / gallery.clientWidth)));
        counter.textContent = `${index + 1} / ${gallery.children.length}`;
        gallery.closest('.pdp').querySelector('[data-gallery-prev]').disabled = index === 0;
        gallery.closest('.pdp').querySelector('[data-gallery-next]').disabled = index === gallery.children.length - 1;
      };
      gallery.addEventListener('scroll', update, { passive: true });
      new ResizeObserver(update).observe(gallery);
      update();
    });
    root.querySelectorAll('[data-featured-rail]').forEach(rail => {
      if (rail.dataset.initialized) return;
      rail.dataset.initialized = 'true';
      const section = rail.closest('.home-products');
      const progress = section.querySelector('[data-featured-progress]');
      let startX = 0;
      let startLeft = 0;
      let dragged = false;
      let activePointer = null;
      const update = () => {
        const maximum = Math.max(0, rail.scrollWidth - rail.clientWidth);
        const visible = rail.scrollWidth ? Math.max(12, (rail.clientWidth / rail.scrollWidth) * 100) : 100;
        const offset = maximum ? (rail.scrollLeft / maximum) * (100 - visible) : 0;
        if (progress) {
          progress.style.width = `${visible}%`;
          progress.style.marginLeft = `${offset}%`;
        }
      };
      rail.addEventListener('pointerdown', event => {
        dragged = false;
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        activePointer = event.pointerId;
        startX = event.clientX;
        startLeft = rail.scrollLeft;
      });
      rail.addEventListener('dragstart', event => event.preventDefault());
      rail.addEventListener('pointermove', event => {
        if (activePointer !== event.pointerId || !(event.buttons & 1)) return;
        const distance = event.clientX - startX;
        if (!dragged && Math.abs(distance) <= 8) return;
        if (!dragged) {
          dragged = true;
          rail.setPointerCapture(event.pointerId);
          rail.classList.add('is-dragging');
        }
        rail.scrollLeft = startLeft - distance;
      });
      rail.addEventListener('pointerup', event => {
        activePointer = null;
        if (rail.hasPointerCapture(event.pointerId)) rail.releasePointerCapture(event.pointerId);
        rail.classList.remove('is-dragging');
      });
      rail.addEventListener('pointercancel', event => {
        activePointer = null;
        dragged = false;
        if (rail.hasPointerCapture(event.pointerId)) rail.releasePointerCapture(event.pointerId);
        rail.classList.remove('is-dragging');
      });
      rail.addEventListener('click', event => {
        if (!dragged) return;
        event.preventDefault();
        event.stopPropagation();
        dragged = false;
      }, true);
      rail.addEventListener('scroll', update, { passive: true });
      new ResizeObserver(update).observe(rail);
      update();
    });
    root.querySelectorAll('.product-form').forEach(form => {
      if (form.dataset.initialized) return;
      form.dataset.initialized = 'true';
      const select = form.querySelector('[name="id"]');
      const picker = form.querySelector('[data-variant-picker]');
      if (picker) {
        const choices = [...picker.querySelectorAll('[data-variant-choice]')];
        picker.hidden = false;
        select.hidden = true;
        const label = form.querySelector(`label[for="${select.id}"]`);
        if (label) {
          label.id = `${select.id}-label`;
          label.removeAttribute('for');
          picker.querySelector('summary').setAttribute('aria-describedby', label.id);
        }
        const syncPicker = () => {
          const option = select.selectedOptions[0];
          const choice = choices.find(button => button.dataset.variantChoice === option.value);
          picker.querySelector('[data-variant-label]').textContent = choice?.dataset.title || option.textContent;
          picker.querySelector('[data-variant-status]').textContent = option.dataset.available === 'true' ? '' : 'Out of stock';
          choices.forEach(button => button.setAttribute('aria-pressed', String(button === choice)));
        };
        choices.forEach(button => button.addEventListener('click', () => {
          select.value = button.dataset.variantChoice;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          picker.open = false;
          picker.querySelector('summary').focus();
        }));
        select.addEventListener('change', syncPicker);
        picker.addEventListener('keydown', event => {
          if (event.key === 'Escape') {
            picker.open = false;
            picker.querySelector('summary').focus();
            event.preventDefault();
          }
          if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
            event.preventDefault();
            picker.open = true;
            let index = choices.indexOf(document.activeElement);
            index = event.key === 'Home' ? 0 : event.key === 'End' ? choices.length - 1 : event.key === 'ArrowDown' ? Math.min(index + 1, choices.length - 1) : index < 0 ? choices.length - 1 : Math.max(index - 1, 0);
            choices[index]?.focus();
          }
        });
        picker.addEventListener('focusout', event => {
          if (event.relatedTarget && !picker.contains(event.relatedTarget)) picker.open = false;
        });
        syncPicker();
      }
      const quantity = form.querySelector('[name="quantity"]');
      const steps = [...form.querySelectorAll('[data-quantity-step]')];
      const syncQuantity = () => {
        steps.forEach(button => button.disabled = Number(button.dataset.quantityStep) < 0 && Number(quantity.value) <= Number(quantity.min || 1));
      };
      steps.forEach(button => {
        button.hidden = false;
        button.addEventListener('click', () => {
          if (!quantity.validity.valid) quantity.value = quantity.min || '1';
          if (Number(button.dataset.quantityStep) > 0) quantity.stepUp();
          else quantity.stepDown();
          quantity.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      quantity.addEventListener('input', syncQuantity);
      quantity.addEventListener('change', syncQuantity);
      syncQuantity();
      form.addEventListener('change', () => {
        const option = form.querySelector('[name="id"]').selectedOptions[0];
        const button = form.querySelector('[name="add"]');
        button.disabled = option.dataset.available !== 'true';
        button.textContent = button.disabled ? 'Out of stock' : 'Add to Bag';
        form.closest('.pdp').querySelector('[data-product-price]').textContent = option.dataset.price;
        const url = new URL(location.href);
        url.searchParams.set('variant', option.value);
        history.replaceState({}, '', url);
      });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        const button = form.querySelector('[name="add"]');
        if (button.disabled) return;
        const error = form.querySelector('.form-error');
        error.hidden = true;
        button.disabled = true;
        button.textContent = 'Adding…';
        const rootPath = window.Shopify?.routes?.root || '/';
        try {
          const response = await fetch(`${rootPath}cart/add.js`, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || 'Unable to add this item. Please try again.');
          if (window.TayacueCart) {
            await window.TayacueCart.open(button);
            button.disabled = false;
            button.textContent = 'Add to Bag';
          } else location.assign(`${rootPath}cart`);
        } catch (e) {
          error.textContent = e.message;
          error.hidden = false;
          button.disabled = false;
          button.textContent = 'Add to Bag';
        }
      });
    });
    applyArchiveFilter();
  };
  init();
  document.addEventListener('shopify:section:load', () => init());
})();
